import React, { PureComponent } from 'react';

import OneVisualLayout from '../../layouts/one-visual';

import Image from '../../../../../containers/assets/instructor-what-to-expect-next.png'

class WhatToExpectNext extends PureComponent {
  render() {
    const { activeRound } = this.props;
    const content = activeRound === 1
      ? 'There will be new supply chain decisions that will impact both revenues and costs.'
      : 'In round 3, scoring metrics and valuation have shifted towards profitability. Therefore, teams have to make a profit and should spend time evaluating their prior round financials to make informed marketing mix, supply chain, and financing decisions.';
    return (
      <OneVisualLayout
        section="What to expect next"
        title={`What’s New in Round ${activeRound + 1}`}
        paragraph1={(
          <p>{content}</p>
        )}
        visual={(
          <img src={Image} alt='What to expect next' />
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    );
  }
}

export default WhatToExpectNext;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/what-to-expect-next/index.js